import React from "react"

import { Link } from "gatsby"
import CTA from "../../components/CTA"
import { Container } from "@material-ui/core"
import Layout from "../../components/Layout"

import Hero from "../../components/Hero"







function AboutUs() {
  return (
    <Layout
      cssClass="cloud services--page"
      title="INVIZ AI Solutions | Cloud Services"
      description="We are a global software and intelligence consultancy company focused on building software, cloud and data solutions with intelligence."
    >
      <Hero>      
        <p className="xlarge"> Build stable, secure and hyper-available applications and services using popular cloud services, such as Amazon Web Services,Google Cloud Platform and Microsoft Azure</p>
      </Hero>




      <section className="text-center cloud-benefits">
        <Container>
        <p>Cloud makes it easier to embrace digital transformation and to enable ML and AI capabilities, allowing you to focus on your core business functions. </p>
        <br />
          <header className="centered">
            <h3>             
                <strong>Benefits of Cloud</strong>             
            </h3>           
          </header>
          <br />

          <ul className="flex">



          <li className="xs-6 md-3">   
            <Link
                  to="/services/ai-machine-learning"     
                  className="ai"            
                >           
              <div className="text">
             
                <h4>
                  <b>Scalability</b>
                </h4>
                <div className="text__">
                <p>
                Cloud gives you the ability to both scale up and scale down based on business requirements. Be a marketing/ sales surge, or response to events like Covid - Cloud can help manage your IT infrastructure better 
                </p>
                  </div>
               
              </div>    
              </Link>          
            </li>

            <li className="xs-6 md-3">
              
              
              <Link
                  to="/services/application-development"   
                  className="app"               
                >
                  <div className="text">
                <h4>
                  <b>Lower Costs</b>
                </h4>
                <div className="text__">
                <p>
                With cloud, you can reduce upfront infrastructure expenses and pay as you scale, bringing down the overall cost of ownership.</p>              
                  <span>
                  Learn More
                  </span>
                  </div>
                  </div>
                </Link>
             
              
            </li> 
            <li className="xs-6 md-3">
            <Link 
                to="/services/cloud-services" 
                className="cloud"
                >
              <div className="text">
               
                <h4>
                  <b>Availability</b>
                </h4>
                <div className="text__">
                <p>
                Could, when implemented well, can delivery hyper-available systems and services with near zero downtime.
                </p>              
                
                  <span>
                  Learn More
                  </span>
                  </div>
                
              </div>
              </Link>
              
            </li>

            <li className="xs-6 md-3">
              
              
              <Link
                  to="/services/application-development"   
                  className="app"               
                >
                  <div className="text">
                <h4>
                  <b>Security</b>
                </h4>
                <div className="text__">
                <p>
                Contemporary cloud implementations are significantly more secure than on-prem solutions,thanks to the security protocols by the gatekeeper (  GCP, Azure or AWS ) and established cloud security best practices
                </p>              
                  <span>
                  Learn More
                  </span>
                  </div>
                  </div>
                </Link>
             
              
            </li>            
           
          </ul>
        </Container>
      </section>

 
      

 
      <section className="cloud-expertise">
        <Container>
          <header className="centered">
            <h3><strong>Our Cloud <span className="green">Services</span></strong></h3>
          </header>
          <div className="text-center">
          <p>
          No matter what the maturity stage of your cloud adoption, Inviz’s command on cloud implementations can help your company in your cloud transformation journey to maximize your product impact, ROI and minimize risk and expenses. 
          </p>
          </div>
          <br/>
          <ul className="flex">
            <li className="xs-12 sm-6">
              <div className="consulting">
                <h4><b>Cloud Consulting</b></h4>
                <p>We partner with companies to build a fool proof cloud strategy to exploit cloud technology and to enhance their business capabilities.</p>
              </div>
            </li>
            <li className="xs-12 sm-6">
              <div className="migration">
                <h4><b>Cloud Migration</b></h4>
                <p>Taking your business to cloud can be a challenging task, that involves multiple risks. We work with companies to do a seamless migration to cloud, with minimal or no impact to business as usual</p>
              </div>
            </li>
            <li className="xs-12 sm-6">
              <div className="security">
              <h4><b>Cloud Security</b></h4>
                <p>In most development environments, developers are under tremendous pressure to deliver features. In such scenarios, vulnerabilities are inevitable. Inviz’s cloud security audits and recommendations can help avert major business threats</p>
              </div>
            </li>
            <li className="xs-12 sm-6">
              <div className="devops">
              <h4><b>DevOps Consulting</b></h4>
                <p>Integrating technology, operations, development, testing and deployment is the foundation of DevOps. Our devOps best practices ensure a seamless interfacing between various stake holders in a secure fashion, enabling par excellence experience for the end user.</p>
              </div>
            </li>
          </ul>
        </Container>
      </section>
      <CTA>
      If you feel, we could help <b className="green">solve your business problem</b>,          
      </CTA>
    </Layout>
  )
}

export default AboutUs
